// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Strategy',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [101, 99, 103, 105, 107],
      pageIdList: '',
      pageIdList_pc: [100, 98, 102, 104, 106],
      pageIdList_mp: [109, 108, 250, 111, 112],
      videoList: '',
      pageInfo: '',
      myPlayer: '',
      videoInfo: '',
      videoStatus: false,
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.switchAdlist();
  },
  methods: {
    init() {
      this.pageInfo = '';
      this.videoList = '';
      this.videoInfo = '';
      this.getAdPictureList();
      this.getPageInfo();
    },
    // 根据客户端切换广告位id
    switchAdlist() {
      if (this.isPC) {
        this.pageIdList = this.pageIdList_pc;
      } else {
        this.pageIdList = this.pageIdList_mp;
      }
      this.init();
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0 && res.data != undefined && res.data.length > 0) {
          this.videoList = res.data;
          this.videoInfo = res.data[0];
          this.initVideo();
        }
      });
    },
    // 根据id获取页面内容
    getPageInfo() {
      const param = {
        lang: this.language,
        adId: this.pageIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data[0];
        }
      });
    },
    // 关闭弹层
    closePopup() {
      this.myPlayer.pause();
      this.videoStatus = false;  
      this.videoInfo = '';
    },
    // 打开视频弹层
    openVideoPopup(index) {
      this.videoInfo = this.videoList[index];
      console.log(this.videoInfo.title);
      this.myPlayer.src(this.videoInfo.video);  //重置video的src
      this.myPlayer.poster(this.videoInfo.image);  //重置video的poster
      this.myPlayer.load(this.videoInfo.video);  //使video重新加载
      this.videoStatus = true;
    },
    // 视频初始化
    initVideo() {
      //初始化视频方法
      this.myPlayer = this.$video(myVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        posterImage: true,
        loop: true,
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: false,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "1200px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "400px",
        sources: [{
          src: this.videoInfo.video,
          type: 'video/mp4'
        }],
      });
      console.log('video init over!')
    },
  },
};
